import { Navigate, useParams } from 'react-router-dom';

import { LoaderComponent } from '@/shared/components/ui';

import { ROUTER_PATHS, useCheckPermissions } from '@/shared';
import { PermissionsEnum } from '@/auth/interfaces';
import SaveCooperativa from '../../saveCooperativa/saveCooperativa';
import { useGetCooperativa } from '@/shared/actions/erp/cooperativa.actions';

export interface UpdateEntidadesFinancierasPageInterface { }

const UpdateCooperativaPage: React.FC<UpdateEntidadesFinancierasPageInterface> = () => {
  useCheckPermissions(PermissionsEnum.api_change_entidadfinanciera)
  const { id } = useParams();
  const { data, isLoading } = useGetCooperativa(id!);

  if (isLoading) return <LoaderComponent />;

  if (!data?.data?.id_cooperativa) return <Navigate to={ROUTER_PATHS.administration.cooperativa_nav} />;

  return <SaveCooperativa titlePage="Editar cooperativa" editCooperativa={data.data} />;
};

export default UpdateCooperativaPage;
